module.exports = __webpack_public_path__ + "static/img/ta1-3.310497f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/ta1-3.png
// module id = 757
// module chunks = 0